import buildI18nRoutesFromConfigure from './buildI18nRoutesFromConfigure';

export function createBuildI18nRoutesFromConfigure(config: any) {
    return (params: any, options?: any, mode?: any) =>
        buildI18nRoutesFromConfigure(params?.data, config, options, mode);
}

// noinspection JSUnusedGlobalSymbols
export default createBuildI18nRoutesFromConfigure;
